module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.426368c9.svg";